<template>
  <div class="buttons quick-actions">
    <b-tooltip v-if="exportButtonActive" :label="$gettext('Public.action.export')" position="is-top">
      <button
        class="button"
        style="border: 0px; background-color: transparent;"
        @click="showExportModal = true"
      >
        <b-icon pack="fa" icon="download"></b-icon>
      </button>
    </b-tooltip>
    <b-tooltip
      v-if="exportButtonDisabled"
      :label="$gettext('Public.action.export.disabled')"
      position="is-top"
      multilined
    >
      <button disabled class="button" style="border: 0px; background-color: transparent;">
        <b-icon type="is-lightgray" pack="fa" icon="download"></b-icon>
      </button>
    </b-tooltip>

    <b-tooltip v-if="qaShare" :label="$gettext('Public.action.share')" position="is-top">
      <b-dropdown position="is-bottom-left">
        <button class="button" style="border: 0px; background-color: transparent;" slot="trigger">
          <b-icon
            pack="fa"
            icon="link"
          ></b-icon>
        </button>
        <b-dropdown-item @click="shareAsSimple()">
          <translate>Public.action.share.default</translate>
        </b-dropdown-item>
        <b-dropdown-item v-if="hasQueryParams()" @click="shareAsSimpleWithQueryParams()">
          <translate>Public.action.share.defaultWithSearchOptions</translate>
        </b-dropdown-item>
        <b-dropdown-item v-if="isCompact()" @click="shareAsCompact()">
          <translate>Public.action.share.compact</translate>
        </b-dropdown-item>
        <b-dropdown-item v-if="isCompact() && hasQueryParams()" @click="shareAsCompactWithQueryParams()">
          <translate>Public.action.share.compactWithSearchOptions</translate>
        </b-dropdown-item>
      </b-dropdown>
    </b-tooltip>

    <b-tooltip v-if="qaPrint" :label="$gettext('Public.action.print')" position="is-top">
      <button
        class="button"
        style="border: 0px; background-color: transparent;"
        @click="print"
      >
        <b-icon
          pack="fa"
          icon="print"
        ></b-icon>
      </button>
    </b-tooltip>
    <b-modal
      :active.sync="showExportModal"
      has-modal-card scroll="keep"
      ref="fobExportModal"
    >
      <fob-public-list-export></fob-public-list-export>
    </b-modal>

  </div>
</template>

<script>

import { CopyToClipboard, ToastSuccess, ToastError } from '@/utils'
import { mapGetters } from 'vuex'

// COMPONENTS
import PublicListExport from '@/components/public/PublicListExport'

export default {
  name: 'fob-public-list-quick-actions',
  data () {
    return {
      showExportModal: false
    }
  },
  props: {
    'qa-share': {
      type: [Boolean, Object],
      default: false
    },
    'qa-print': {
      type: Boolean,
      default: false
    },
    'qa-export': {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isCompact () {
      return this.qaShare && this.qaShare.hasOwnProperty('compact') ? this.qaShare.compact : false
    },
    hasQueryParams () {
      return this.qaShare && this.qaShare.hasOwnProperty('queryParams')
    },
    urlPath () {
      return `${window.location.origin}/portal${this.$route.path}`
    },
    urlQueryParams () {
      return Object
        .entries(this.qaShare.queryParams)
        .filter(([_, filterValue]) => filterValue != null)
        .map(([filterName, filterValue]) => `${filterName}=${encodeURIComponent(filterValue)}`)
        .join('&')
    },
    copyToClipboard (text) {
      CopyToClipboard(text).then(() => {
        ToastSuccess(this.$gettext('Public.toast.clipboard.success'))
      }, () => {
        ToastError(this.$gettext('Public.toast.clipboard.error'))
      })
    },
    print () {
      window.print()
    },
    shareAsSimple () {
      let url = this.urlPath()
      this.copyToClipboard(url)
    },
    shareAsSimpleWithQueryParams () {
      let url = `${this.urlPath()}?${this.urlQueryParams()}`
      this.copyToClipboard(url)
    },
    shareAsCompact () {
      let url = `${this.urlPath()}?compact=true`
      this.copyToClipboard(url)
    },
    shareAsCompactWithQueryParams () {
      let url = `${this.urlPath()}?compact=true&${this.urlQueryParams()}`
      this.copyToClipboard(url)
    }
  },
  computed: {
    ...mapGetters({
      userIsLoggedIn: 'user/isAuthorized',
      rootQueryType: 'publicView/getRootQueryType'
    }),
    userIsAdmin () {
      return this.userIsLoggedIn && this.$store.getters['user/roles'].ADMIN === true
    },
    exportButtonDisabled () {
      return this.qaExport && !this.userIsLoggedIn && (this.rootQueryType === 'organisationalUnit')
    },
    exportButtonActive () {
      return this.qaExport && this.userIsLoggedIn && (this.rootQueryType === 'organisationalUnit')
    }
  },
  components: {
    'fob-public-list-export': PublicListExport
  }
}

</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/public/PublicListQuickActions.vue